/* istanbul ignore file */
import makeApi from '@lib/api'

export interface RegistrationRequest {
  retailerPartnerNumber: number | null
  memberId: string
}

export interface RegistrationRequestBody {
  reg_token: string
}

export interface RegistrationResponse {
  message: string
  status: string
}

export const finishRegistration = async (args: RegistrationRequest, body: RegistrationRequestBody) => {
  // eslint-disable-next-line max-len
  const callApi = makeApi.post<{}, RegistrationRequestBody, RegistrationResponse>(
    `/v1/loyalty/retailers/${args.retailerPartnerNumber}/members/${args.memberId}/_finish_registration`,
  )
  return await callApi({ body, params: {} })
}
